/**
 * Get default site (Attribute 42)
 * @returns {String} Default site value or page url
 */
export function getDefaultSiteByDomain() {
	let page = window.modForm.opts.websiteName.replace(/(qa|staging|www)./g, '');
	page = page.replace('m.', '');
	return page;
}
